"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TextScanner;
function TextScanner(props) {
  return;
}